import { Box } from '@material-ui/core/';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getVariantsForCIEM } from '../../reducers/shopify_api/ShopifyCIEMSlice';
import getIdForModel from '../../utils/getIdForModel';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';
const InBoxDetails = () => {
    const { t } = useTranslation();
    const state = useSelector((state) => state);
    const model = useSelector((state) => state.rootReducer.currentModel);
    const id = getIdForModel(state.shopifyReducer.ciems, model.currentModel.name);
    useEffect(() => {
        if (id) {
            dispatch(getVariantsForCIEM(id));
        }
    }, [id]);
    const dispatch = useDispatch();

    const inBoxDesc = model.currentModel.inTheBox.description;
    const inBoxComponents = inBoxDesc.map((value, count) => {
        let translated = '';
        if (value.includes('Custom In-Ear Monitors') === true) {
            translated = `${model.currentModel.name} ${t(
                'summary.in_the_box.custom_in_ear_monitors'
            )}`;
        } else {
            translated =
                t(`summary.in_the_box.${value}`) !== `summary.in_the_box.${value}`
                    ? t(`summary.in_the_box.${value}`)
                    : value;
        }
        return (
            <span className={layout.containerInBox} key={count}>
                {count !== 0 && ' •'} {translated}
            </span>
        );
    });
    return (
        <Box
            style={{
                width: '90%',
                height: '100%',
                marginLeft: '5%',
                display: 'flex',
                flexDirection: 'column'
            }}>
            <Box
                style={{
                    height: '40%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    flexDirection: 'column'
                }}>
                <h4 style={{ textAlign: 'center' }} className={typography.inBoxTitle}>
                    {t('summary.in_the_box.title')}
                </h4>
            </Box>
            <Box
                style={{
                    textAlign: 'center',
                    display: 'flex',
                    height: '60%',
                    alignItems: 'center'
                }}>
                <span>{inBoxComponents}</span>
            </Box>
        </Box>
    );
};

export default InBoxDetails;
